import React from "react";
import { match as matchPropTypes } from "react-router-prop-types";
import { CSSTransitionGroup } from "react-transition-group";
import UnsavedChangesPrompt from "src/Components/UnsavedChangesPromt";
import PageTitle from "src/Layout/AppMain/PageTitle";
import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import TotalRewardCategoriesForm from "src/Pages/Company/TotalReward/Categories/Edit/form";
import __ from "src/utils/Translations";

export default function TotalRewardCategoryEdit({ match }) {
  const { categoryId } = match.params;
  const isNew = categoryId === "-1";
  const companyId = useCompanyId();
  const companyName = useCompanyName();
  const pathPrefix = `/ahr`;

  return (
    <>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <PageTitle
          heading={
            isNew
              ? __(`Tworzenie kategorii w firmie {0}`, [companyName])
              : __(`Edycja kategorii (ID: {0}) w firmie {1}`, [
                  categoryId,
                  companyName,
                ])
          }
          breadcrumbsHeading={
            isNew
              ? __("Tworzenie kategorii")
              : `${__("Edycja kategorii")} (ID: ${categoryId})`
          }
          pushToHistory
          breadcrumbs={[
            {
              title: "Total Reward Statement",
              link: `${pathPrefix}/total-reward`,
            },
            {
              title: __("Zarządzanie kategoriami benefitów"),
              link: `${pathPrefix}/total-reward/categories`,
            },
          ]}
        />
        <UnsavedChangesPrompt>
          <TotalRewardCategoriesForm
            categoryId={categoryId}
            listingUrl={`${pathPrefix}/total-reward/categories`}
          />
        </UnsavedChangesPrompt>
      </CSSTransitionGroup>
    </>
  );
}

TotalRewardCategoryEdit.propTypes = {
  match: matchPropTypes.isRequired,
};
